export default {"src":"/_next/static/media/icon_nav_dd_roadmap_off.27c3b6b0.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};